;(function() {
  'use strict'

  Config.$inject = ["$stateProvider"];
  angular.module('app.core').config(Config)

  /* @ngInject */
  function Config($stateProvider) {
    $stateProvider.state('app.plan', {
      url: '/plans/:id',
      templateUrl: 'plan.html',
      controller: 'Plan',
      controllerAs: '$ctrl',
    })
  }
})()
